import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Receipt.css';

export default class Receipt extends Component { 

  constructor(props){
    super(props);
    this.state = {};
  }

  componentDidMount(){
    this.baseUrl = process.env.REACT_APP_API_URL;
    this.getBookingDetails();
  }
  
  getBookingDetails(){
    const urlParams = new URLSearchParams(window.location.search);
    let bookingId = urlParams.get('id');
    if(!bookingId){
      toast.dismiss();
      toast.error("Params missing in URL!");
      return;
    }
    this.setState({loading: true})
    fetch(`${this.baseUrl}/parking/valet/booking/info/hash?hash=${bookingId}`)
        .then(response => response.json())
        .then(resp => {
          if(resp.data && resp.status === "SUCCESS"){
            this.setState({
                data: resp.data
            })
          }else{
            let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong'; 
            this.setState({loading: false});
            toast.dismiss();
            toast.error(errMsg);
          }
        })
        .catch((error) => {
          this.setState({loading: false});
          toast.dismiss();
          toast.error('Something went wrong');
        });
  }

  getDate(dateString){
    if(!dateString || !dateString.includes(',')) return;
    let indexOfSecondComma = dateString.indexOf(",", dateString.indexOf(",") + 1);
    let dataBeforeSecondComma = "";
    if (indexOfSecondComma !== -1) {
      dataBeforeSecondComma = dateString.substring(0, indexOfSecondComma).trim();
    }
    return dataBeforeSecondComma;
  }


  render() {
    const data = this.state.data;
    if(!data) return (<>
      <div className='receipt-loading'>Getting your receipt...</div>
      <ToastContainer autoClose={2000} closeButton={true} style={{fontSize: 14}}/>
    </>)
    return (
      <div className="receipt">
        <div className='top-wrap'>
            <div className='top-section'>
                <div class="top-logo get-flex">
                    <div class="get-col column">
                        <img style={{height: '53px', position: 'relative', top: '-15px', left: '-12px'}} src="https://portal.parkquility.com/public/pq_logo.png" />
                    </div>
                    <div class="get-col column">
                        <div className='text-right'>Total: {data.payment_type === "cash" && (data.parking_fee > 0 || data.tip2 > 0) ? '$' + ((data.parking_fee + data.tip2)/100).toFixed(2) : data.total_fee ? '$'+ (data.total_fee/100).toFixed(2) : '$0.00'}</div>
                        <div className='text-right'>{this.getDate(data.booking_end_time)}</div>
                    </div>
                </div>
            </div>    
            <h4>Thanks for Parking with Parkquility</h4>
            <p>We hope you had an excellent experience.</p>
        </div>
        <div className='get-flex mid-section'>
            <div className='get-col'>Total</div>
            <div className='get-col text-right'>{data.payment_type === "cash" && (data.parking_fee > 0 || data.tip2 > 0) ? '$' + ((data.parking_fee + data.tip2)/100).toFixed(2) : data.total_fee ? '$'+ (data.total_fee/100).toFixed(2) : '$0.00'}</div>
        </div>
        <div className='booking-info'>
            <div className='get-flex'>
              <div className='get-col'>Booking Id</div>
              <div className='get-col text-right'>{data.employee === 'true' ? 'E-' : 'C-'}{data.id} - {data.keyboard_slot}</div>
            </div>
            <div className='get-flex'>
                <div className='get-col'>Name</div>
                <div className='get-col text-right'>{`${data.first_name} ${data.last_name}`}</div>
            </div>
            <div className='get-flex'>
                <div className='get-col'>License Plate</div>
                <div className='get-col text-right'>{data.vehicle_no}</div>
            </div>
            <div className='get-flex'>
                <div className='get-col'>Mobile</div>
                <div className='get-col text-right'>{data.country_code}-{data.contact_number}</div>
            </div>
            <div className='get-flex'>
                <div className='get-col'>Start Time</div>
                <div className='get-col text-right'>{data.start_date_time}</div>
            </div>
            <div className='get-flex'>
                <div className='get-col'>End Time</div>
                <div className='get-col text-right'>{data.end_date_time}</div>
            </div>
            <div className='get-flex'>
                <div className='get-col'>Payment Type</div>
                <div style={{textTransform: 'capitalize'}} className='get-col text-right'>{data.payment_type ? data.payment_type.replace("_", " ") : ''}</div>
            </div>
            <div className='get-flex'>
                <div className='get-col'>Parking Fee</div>
                <div className='get-col text-right'>${data.parking_fee > 0 || data.tip2 > 0 ? ((data.parking_fee + data.tip2)/100).toFixed(2) : '0.00'}</div>
            </div>
            <div className='get-flex'>
                <div className='get-col'>Tip</div>
                <div className='get-col text-right'>${data.tip_amount ? (data.tip_amount/100).toFixed(2) : '0.00'}</div>
            </div>
            <div className='get-flex'>
                <div className='get-col'>Convenience Fee</div>
                <div className='get-col text-right'>${data.conv_fee ? (data.conv_fee/100).toFixed(2) : '0.00'}</div>
            </div>
            <div className='get-flex'>
                <div className='get-col'>Total Fee</div>
                <div className='get-col text-right'>{data.payment_type === "cash" && (data.parking_fee > 0 || data.tip2 > 0) ? '$' + ((data.parking_fee + data.tip2)/100).toFixed(2) : data.total_fee ? '$'+ (data.total_fee/100).toFixed(2) : '$0.00'}</div>
            </div>
            <div className='get-flex'>
                <div className='get-col'>Location</div>
                <div className='get-col text-right'>{data.arena_name}</div>
            </div>
        </div>
        <ToastContainer autoClose={2000} closeButton={true} style={{fontSize: 14}}/>
      </div>
    )
  }
}